<template>
  <div class="search-container" :class="{ placeholding }">
    <div class="search">
      <div class="search-content" :class="{ hide }">
        <v-text-field
          solo
          rounded
          clearable
          prepend-inner-icon="search"
          :placeholder="placeholder"
          :value="modelValue"
          @input="onInput($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Debouncer } from '@/shared/services/debouncer';

// THIS IS DEPRECATED.
export default {
  name: 'StickySearch',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    placeholding: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      default: '',
    },
    hide: {
      type: Boolean,
      default: false,
    },
    inputEventDebounceMs: {
      type: Number,
      default: 200,
    },
  },
  data() {
    return {
      value: '',
      debouncer: new Debouncer(this.emitInputEvent, this.inputEventDebounceMs),
    };
  },
  methods: {
    onInput(value) {
      this.value = value;
      this.debouncer.execute();
    },
    emitInputEvent() {
      this.$emit('input', this.value);
    },
  },
};
</script>

<style scoped>
.search-container.placeholding {
  height: 80px;
}

.search {
  position: fixed;
  width: 100%;
  max-width: 600px;
  top: 48px;
  left: 0;
  right: 0;
  padding: 16px;
  margin: auto;
  overflow: hidden;
  z-index: 99;
}

.search-content {
  transition: transform ease-in-out 250ms;
}

.search-content.hide {
  transform: translateY(-100%);
}
</style>
